const Signout = () => <div>You have been signed out</div>;

export default Signout;
